module.exports = __webpack_public_path__ + "static/media/tavater-ashley.f35b7388.png";